import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70156203"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Sua recarga de celular simples e fácil? ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Entre na nossa lista de espera ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" E seja um dos primeiros a ter essa ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "novidade", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Recarga de Celular ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Qual número você quer recarregar? ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Celular")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Confirmar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_modal, {
        ref: "modal",
        "is-open": _ctx.isOpenAtivacao,
        "initial-breakpoint": 0.70,
        breakpoints: [0.80]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper, {
                pagination: true,
                modules: _ctx.modules,
                autoplay: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b1",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "b2",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "b3",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_3,
                              _hoisted_4
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modules"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, { size: "2" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_ion_button, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
                      size: "large",
                      fill: "#fff"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "start",
                          icon: _ctx.chevronBack
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_col, {
                size: "9",
                class: "font-poppins-extra font-25"
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_swiper, {
            allowTouchMove: false,
            onSwiper: _ctx.onSwiper,
            onReachBeginning: _ctx.onFirst,
            onReachEnd: _ctx.onLast
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-poppins-extra font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _hoisted_7
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-raleway font-30",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createElementVNode("input", {
                            type: "tel",
                            class: "input-cadastro",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.recarga.celular) = $event)),
                            onMaska: _cache[2] || (_cache[2] = ($event: any) => (_ctx.recarga.celular_v = $event.target.dataset.maskRawValue))
                          }, null, 544), [
                            [_vModelText, _ctx.recarga.celular],
                            [_directive_maska, ['(##)# ####-####', '(##)# ####-####']]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "ion-text-center font-raleway font-12",
                        size: "12"
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSwiper", "onReachBeginning", "onReachEnd"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                class: "ion-text-center font-raleway",
                size: "8"
              }),
              (!_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    class: "ion-text-center",
                    size: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toEnd())),
                        color: "danger",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, { icon: _ctx.icon_right }, null, 8, ["icon"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 1,
                    class: "ion-text-center",
                    size: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.callSignUP())),
                        color: "danger",
                        size: "large",
                        shape: "round",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}